module.exports = __webpack_public_path__ + "img/zip_08_cerna.54fad7e0.png";